export default __webpack_public_path__ + "static/media/kom.0ce8d4db.jpg";